// extracted by mini-css-extract-plugin
module.exports = {"brokerBoxArticleAd":"styles_brokerBoxArticleAd__pGoVx"};